import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule} from '@angular/material/card';
import { MatMenuModule} from '@angular/material/menu';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule} from '@angular/material/icon';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatTableModule} from '@angular/material/table';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { ScrollingModule } from '@angular/cdk/scrolling';         

//Routing
import { PublicRoutingModule } from './publicRouting.module';

//pipes
import { EnvPipe } from './pipes/EnvPipe';

//import {fakeBackendProvider} from './helper/fackeBackEnd';

//import { BasicAuthInterceptor } from './helper/auth.interceptor';
//import { ErrorInterceptor } from './helper/error.interceptor';
import { PublicLayoutComponent } from './layout/publicLayout.component';
import { HeaderComponent } from './layout/header.component';
import { LoginComponent } from './login/login.component';
import { ThemeToggleComponent } from '@app/shared/themeToggle/themeToggle.component';

@NgModule({
    declarations: 
    [
        PublicLayoutComponent,
        HeaderComponent,
        LoginComponent,
        EnvPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,        
        PublicRoutingModule,
        FormsModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatCardModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatTableModule,
        MatTooltipModule,
        ScrollingModule,
        MatProgressSpinnerModule,
        ThemeToggleComponent
    ],
    exports: [],
    providers: [
   ]    
})
export class PublicModule { }
